import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationStateService } from '../../../../core/services/navigation/navigation-state.service';
import { TranslatePipe } from '../../../pipes/translate/translate.pipe';
import { IcChevronDownComponent } from '../../Icons/ic-chevron-down/ic-chevron-down';
import { ModuleIconComponent } from '../module-icon/module-icon.component';

/**
 * ModuleSwitcherComponent component.
 * Provides UI presentation and event handling for module switcher component.
 */
@Component({
  selector: 'app-module-switcher',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IcChevronDownComponent, ModuleIconComponent, TranslatePipe],
  templateUrl: './module-switcher.component.html',
  styleUrl: './module-switcher.component.scss',
})
export class ModuleSwitcherComponent {
  /** Injected service for navigation state. */
  readonly navigationState = inject(NavigationStateService);

  /**
   * Handles on toggle logic.
   * @param event - The event
   */
  onToggle(event: Event): void {
    event.stopPropagation();
    this.navigationState.toggleMegaMenu();
  }
}
